import { render, staticRenderFns } from "./ContractSectionBuilder.vue?vue&type=template&id=2ce97046&scoped=true"
import script from "./ContractSectionBuilder.vue?vue&type=script&lang=js"
export * from "./ContractSectionBuilder.vue?vue&type=script&lang=js"
import style0 from "./ContractSectionBuilder.vue?vue&type=style&index=0&id=2ce97046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce97046",
  null
  
)

export default component.exports